import React, {useState, useEffect} from 'react';
import {useParams, useLocation, useNavigate} from 'react-router-dom';
import FormConstants from '@shared/constants/FormConstants';
import ModuleSearchPage from '@modules/home/main/modules-menu/modules-search-page/ModuleSearchPage';
import UserAccess from './user-access/UserAccess';
import AuditTrailComponent from './audit-trails/AuditTrailComponent';
import AuditLogComponent from './audit-logs/AuditLogComponent';
import {
  BASE_MENU_ITEM,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  USER_ACCESS,
  AR_WORKDOWN,
  BI_TOOL,
  BIIG_PORTAL,
  BASE_LEGACY_APP,
  BASE_RECORD_ID
} from 'src/routes/BaseRoute';
import GLReportsComponent from '../sub-modules-menu/finance/GLReportsComponent';
import PurgeAndLegalHoldComponent from './purge-legal-hold/PurgeAndLegalHoldComponent';
import MarketPlaceComponent from './purge-legal-hold/market-place/MarketPlaceComponent';
import ExternalAudit from './external-audit/ExternalAudit';
import ClinicalReportsComponent from './clinical-reports/ClinicalReportsComponent';
import ModuleLevelTabsComponent from './module-level-tabs/ModuleLevelTabsComponent';
import PharmacyComponent from './pharmacy/PharmacyComponent';
import FeedbackForm from './feedback/FeedbackComponent';
import FileCabinetComponent from './file-cabinet/FileCabinetComponent';
import {useAppContext} from '@context/AppContext';
import {PRIVATE_ROUTES} from 'src/routes/RouteConstants';
import {
  getApplicationListData,
  getModuleListData
  // postUIErrorLog
} from '@shared/services/service-handlers/PrivateService';
import AuthUtils from 'src/utils/AuthUtils';
import CmsComponent from './cms/CmsComponent';
import Header from 'src/layouts/dashboard/header';
import {useBoolean} from 'src/hooks/use-boolean';
import Main from 'src/layouts/dashboard/main';
import NavVertical from 'src/layouts/dashboard/nav-vertical';
import NavMini from 'src/layouts/dashboard/nav-mini';
import {useSettingsContext} from 'src/minimal-components/settings';
import {useResponsive} from 'src/hooks/use-responsive';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {useSnackbar} from 'notistack';
import Departments from 'src/pages/AppRationalization/Departments';
import Financials from 'src/pages/AppRationalization/Financials';
import AppDetails from 'src/pages/AppRationalization/AppDetails';
import AppCosts from 'src/pages/AppRationalization/AppCosts';
import Security from 'src/pages/AppRationalization/Security';
import Projects from 'src/pages/AppRationalization/Projects';
import AppDiscovery from 'src/pages/AppRationalization/AppDiscovery';
import ARDashboard from 'src/pages/AppRationalization/ARDashboard';
import Analysis from 'src/pages/AppRationalization/Analysis';
import ArchiveFlag from 'src/pages/AppRationalization/ArchiveFlag';
import ProjectPlan from 'src/pages/AppRationalization/ProjectPlan';
import Forecast from 'src/pages/AppRationalization/Forecast';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {Container, Stack, Box} from '@mui/material';
import {RoleBasedGuard} from 'src/auth/guard';
import CustomBreadcrumbs from 'src/minimal-components/custom-breadcrumbs/custom-breadcrumbs';
import CourseCatalogComponent from './course-catalog/CourseCatalogComponent';
import Courseinitial from './course-catalog/opening-Coursecatalog/initialpage_ccs';
import SearchNotFound from 'src/minimal-components/search-not-found/search-not-found';
import DataGridComponent from '@components/datagrid/DataGridComponent';
import SupersetComponent from './superset/SupersetComponent';
import PatientAccountingPage from './patient-accounting/PatientAccountingPage';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import FeedbackFormCreation from './course-catalog/Prepostlearning/FeedbackFormCreation';
import FillInTheBlanksQuestionType from './course-catalog/Prepostlearning/Assessment/Addquestion/FillBlanksQuestionType';
import {useModuleContext} from '@context/ModuleContext';
// import PrePostLearning from './course-catalog/Prepostlearning';
// import CreateCertificate from './course-catalog/Prepostlearning/CreateCertificate';
// import TemplateStepperDialog from './course-catalog/Prepostlearning/CreateCertificate';
// import AnimatedCircle, {
//   Paint
// } from './course-catalog/Prepostlearning/AnimatedCircle';
// import Homepage from './course-catalog/Prepostlearning/AnimatedCircle';
// import CertificateEditor from './course-catalog/Prepostlearning/Certificate/CertificatePreview';
// import {DndProvider} from 'react-dnd';
// import {HTML5Backend} from 'react-dnd-html5-backend';
// import App from './course-catalog/Prepostlearning/CreateCertificate';
// import CertificateTool from './course-catalog/Prepostlearning/Certificate/CertificatePreview';
// import TemplateEditor from './course-catalog/Prepostlearning/Certificate/CertificatePreview';
// import ModuleMainPage from './course-catalog/ModulePageComponents/ModuleMainPage';
import {environment} from '@shared/config/environment';
import VideoPlayer from '@components/docViewer/CustomViewers/VideoViewer';
import EnterpriseSearch from './enterprise-search/EnterpriseSearch';
import EncryptUtils from 'src/utils/EncryptUtils';
import LegacyAppFilter from '../sub-modules-menu/sub-module-page-section/LegacyAppFilter';
// import EncryptUtils from 'src/utils/EncryptUtils';

const ModulesMenuHomePage = (): React.ReactElement => {
  const {
    appState: {applicationName}
  } = useAppContext();

  const {enqueueSnackbar} = useSnackbar();
  const params: any = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const menuItem = new URLSearchParams(location?.search).get(BASE_MENU_ITEM);
  const nav = useBoolean();
  const [loading, setLoading] = React.useState(false);
  const [isSearching, setIsSearching] = React.useState(false);
  const [state, setState] = useState({
    activeTab: undefined,
    activeSubTab: undefined,
    data: [],
    loading: false
  });
  const [idlms, setLMS] = useState({
    id: '',
    type: 'new'
  });
  const [externalUrl, setExternalUrl] = React.useState<string>('');
  const {data} = state;

  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const isMini = settings.themeLayout === 'mini';

  const renderNavMini = <NavMini navData={data} isLoading={loading} />;

  const search = useBoolean();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {moduleState, setIsBHData, setIsBHReasonData} = useModuleContext();
  localStorage.removeItem('check_isbh');
  const [searchResults, setSearchResults] = useState<
    Record<string, any>[] | null
  >(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedHelpOption, setSelectedHelpOption] = useState('');
  const [ParentLegacyValue, setParentLegacyValue] = useState('');

  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );

  const legacyApp = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_LEGACY_APP
  );

  const renderParentLegacyAppFilter = () => {
    if (params.module_name === FormConstants.MODULE.FILECABINET) {
      return (
        <LegacyAppFilter
          setParentLegacyValue={setParentLegacyValue}
          defaultLegacyAppValue={ParentLegacyValue}
          record_id={recordId}
        />
      );
    }
  };

  const handleSearch = async (query: string) => {
    setIsSearching(true);
    try {
      const response = await fetch(
        `https://bytepad-db-paid-clinical-medications-dev.search.windows.net/indexes/clinical-medication-index-dev/docs/search?api-version=2016-09-01`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'api-key': 'yt29nZOnt4SSUZK5PFei6hyA3o5TNnt0mqRtD1t8UAAzSeCBW1oU'
          },
          body: JSON.stringify({
            count: true,
            queryType: 'simple',
            search: query,
            searchMode: 'any',
            skip: 0,
            top: 50
          })
        }
      );
      const data = await response.json();
      setSearchResults(data?.value);

      setIsSearching(false);
    } catch (error) {
      const errMessage = getErrorMessage(error);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setIsSearching(false);
    }
  };

  const renderNavVertical = (
    <NavVertical
      navData={data}
      isOpenNav={nav.value}
      onCloseNav={nav.onFalse}
      isLoading={loading}
      setExternalUrl={setExternalUrl}
      applicationName={applicationName}
    />
  );

  const init = async () => {
    try {
      const res = await getModuleListData(applicationName);

      const resData = res.map((item: any) => {
        item.isSubMenuOpened = false;
        return item;
      });

      const basePath = res && res[0]?.items[0];
      setIsBHData(false);
      // setIsBHReasonData('')
      if (
        location.pathname?.replace(/\/$/, '') ===
        `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}`
      ) {
        navigate(`/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/` + basePath?.url, {
          state: {}
        });
      }

      setState((prevState: any) => ({
        ...prevState,
        data: resData,
        loading: false
      }));

      setLoading(false);
    } catch (error) {
      const errMessage = getErrorMessage(error);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoading(false);
    }
  };

  useEffect(() => {
    if (params.module_name) {
      AuthUtils.clearAuditIdentifier();
      AuthUtils.clearAuditIdentifierType();
      AuthUtils.clearAuditLegacyApp();

      setSearchQuery('');
      search.onFalse();
      setSearchResults(null);
      setIsBHData(false);
      setIsBHReasonData('');
      setSelectedHelpOption('');
    }
  }, [params.module_name]);

  useEffect(() => {
    init();
    setLoading(true);
    setState((prevState: any) => ({
      ...prevState,
      loading: true
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleHelpOptionClick = async (url: string) => {
    setSelectedHelpOption(url);
  };

  const handleEditUser = (data: any): void => {
    setLMS((prevState: any) => ({
      ...prevState,
      id: data,
      type: 'edit'
    }));
  };

  // const handleNewUser = (data: any): void => {
  //   setLMS((prevState: any) => ({
  //     ...prevState,
  //     id: ' ',
  //     type: 'new'
  //   }));
  // };
  // const handleViewUser = (data: any): void => {
  //   setLMS((prevState: any) => ({
  //     ...prevState,
  //     id: ' ',
  //     type: 'view'
  //   }));
  // };

  // ----used for the adaptcare lms integration-------------
  // const handleclose = () => {
  //   navigate(
  //     `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}`,
  //     {
  //       state: {}
  //     }
  //   );
  // };

  const handleDeleteUser = (data: any) => {
    setLMS((prevState: any) => ({
      ...prevState,
      id: data.id,
      type: 'delete'
    }));
  };

  useEffect(() => {
    if (applicationName === 'App_Rationalization') {
      return;
    }
    const fetchData = async () => {
      try {
        if (!applicationName?.length) {
          throw new Error('Application name is missing.');
        }
        const {data} = await getApplicationListData();

        const application_found = data.find(
          (item: any) => item.application_name === applicationName
        );
        const userPermission = await AuthUtils.getUserAppPermissions();
        const userPermission_found = userPermission?.find(
          (item: string) => item === applicationName
        );
        // log for Epic
        // const data_log = {
        //   error: JSON.stringify({
        //     userPermission,
        //     userPermission_found,
        //     application_list_data: data,
        //     application_found
        //   }),
        //   error_description: 'Epic Log - ModulesMenuHomePage'
        // };
        // const encryptRequestData = EncryptUtils.encryptedData(data_log);

        // await postUIErrorLog({
        //   tk: encryptRequestData
        // });
        // log for Epic

        if (!application_found || !userPermission_found) {
          throw new Error('Application not found in the data.');
        }
      } catch (error) {
        // log for Epic
        // const data_log = {
        //   error: JSON.stringify({
        //     NavigateToDashboard: 'true',
        //     route: `/${BASE_ROUTE}/${PRIVATE_ROUTES.DASHBOARD}`,
        //     Error: 'Error fetching or processing application data:'
        //   }),
        //   error_description: 'Epic Log - ModulesMenuHomePage'
        // };
        // const encryptRequestData = EncryptUtils.encryptedData(data_log);

        // await postUIErrorLog({
        //   tk: encryptRequestData
        // });
        // log for Epic
        console.error('Error fetching or processing application data:', error);
        return navigate(`/${BASE_ROUTE}/${PRIVATE_ROUTES.DASHBOARD}`, {
          state: {showUnAuthenticatedPopUp: true}
        });
      }
    };

    fetchData();
  }, [applicationName]);

  function formatModuleName(moduleName: string): string {
    if (!moduleName || moduleName.length <= 3) {
      return (moduleName || '').toUpperCase();
    }

    const [firstTwoLetters, rest] = moduleName.split('-');

    // Capitalize first two letters if module name contains only two letters before hyphen
    if (firstTwoLetters.length === 2) {
      const formattedFirstTwoLetters = firstTwoLetters.toUpperCase();
      return `${formattedFirstTwoLetters} ${
        rest.charAt(0).toUpperCase() + rest.slice(1)
      }`;
    }

    const words = moduleName.replace(/_/g, ' ').split(/-| /);

    const formattedModuleName = words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return formattedModuleName;
  }

  const getModulePageItem = () => {
    const currentPath = location?.pathname ?? '';
    // ----used for the adaptcare lms integration-------------
    // const path = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}`;
    // const pathed = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/new`;

    // let currentPath = path; // Default to the standard path

    // // Check if location.pathname includes 'course_management-adaptcare'
    // if (location?.pathname.includes('course_management-adaptcare')) {
    //   currentPath = path; // Use the standard path
    // } else {
    //   // Use location.pathname if it does not include 'course_management-adaptcare' and is equal to pathed
    //   currentPath = location?.pathname === pathed ? location.pathname : path;
    // }
    // console.log(currentPath,`/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.ENTERPRISE_SEARCH}`,BASE_ROUTE,BASE_ROUTE_MODULE,menuItem,'form:',FormConstants.MODULE,menuItem)
    switch (currentPath) {
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${USER_ACCESS}`:
        return <UserAccess module={params.module_name} />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.AUDIT_TRAILS}`:
        return <AuditTrailComponent module={params.module_name} />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.AUDIT_LOGS}`:
        return <AuditLogComponent module={params?.module_name} data={data} />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.ENTERPRISE_SEARCH}/`:
        return (
          <EnterpriseSearch
            module={params?.module_name}
            data={data}
            menuItem={menuItem}
          />
        );
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.MARKETPLACE}`:
        return (
          <MarketPlaceComponent
            CustomBreadcrumbsHeading={formatModuleName(params.module_name)}
          />
        );
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.FEEDBACK}`:
        return <FeedbackForm module={params.module_name} />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.INTEGRATIONS}`:
        return (
          <Stack
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            minHeight={'80vh'}>
            <RoleBasedGuard hasContent={true} sx={{mt: 5}} />
          </Stack>
        );
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.PURGE_AND_LEGAL_HOLD}`:
        return <PurgeAndLegalHoldComponent module={params.module_name} />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.EXTERNAL_AUDIT}`:
        return <ExternalAudit module={params.module_name} />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${AR_WORKDOWN}`:
        return (
          <Stack
            sx={{
              px: 3
            }}>
            <CustomBreadcrumbs
              sx={{
                mt: 2
              }}
              links={[
                {
                  name: formatModuleName(params.module_name),
                  href: ''
                }
              ]}
            />
            <iframe
              src={externalUrl}
              style={{
                width: '100%',
                height: '90vh',
                border: '0'
              }}
            />
          </Stack>
        );
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${BI_TOOL}`:
        return <SupersetComponent />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${BIIG_PORTAL}`:
        return (
          <Stack
            sx={{
              px: 3
            }}>
            {/* <CustomBreadcrumbs
              sx={{
                mt: 2
              }}
              links={[
                {
                  name: formatModuleName(params.module_name),
                  href: ''
                }
              ]}
            /> */}
            <iframe
              src={externalUrl}
              style={{
                width: '100%',
                height: '90vh',
                border: '0'
              }}
            />
          </Stack>
        );
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.FILECABINET}`:
        return (
          <FileCabinetComponent
            module={params.module_name}
            menuItem={menuItem}
            CustomBreadcrumbsHeading={formatModuleName(params.module_name)}
            CustomBreadcrumbsSubheading={formatModuleName(menuItem ?? '')}
          />
        );
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.PHARMACY}`:
        return <PharmacyComponent module={params?.module_name} />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.CLINICAL}`:
        return <ClinicalReportsComponent module={params?.module_name} />;
      // case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.AUDIT_ACCESS_LOGS}`:
      //   return <AuditLogComponent module={params?.module_name} data={data} />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.LIS}`:
        return (
          <ModuleLevelTabsComponent
            key={params?.module_name}
            module={params?.module_name}
          />
        );
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.RIS}`:
        return (
          <ModuleLevelTabsComponent
            key={params?.module_name}
            module={params?.module_name}
          />
        );
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.CMS}`:
        return <CmsComponent />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}`:
        return (
          // <FeedbackFormCreation />
          // <DndProvider backend={HTML5Backend}>
          //   <TemplateStepperDialog />
          // </DndProvider>
          // <ModuleMainPage />
          // <FillInTheBlanksQuestionType />
          <Courseinitial module="course_managements" />
        );
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.PATIENT_ACCOUNTING}`:
        return (
          <PatientAccountingPage
            module={params.module_name}
            menuItem={menuItem}
          />
        );

      default:
        return (
          <ModuleSearchPage
            module={params.module_name}
            menuItem={menuItem}
            CustomBreadcrumbsHeading={formatModuleName(params.module_name)}
            CustomBreadcrumbsSubheading={formatModuleName(menuItem ?? '')}
            handleEditUser={handleEditUser}
            handleDeleteUser={handleDeleteUser}
          />
        );
    }
  };

  const getModulePageItemAR = () => {
    const currentPath = location?.pathname ?? '';
    switch (currentPath) {
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/dashboard`:
        return <ARDashboard />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/analysis`:
        return <Analysis />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/archive-flag`:
        return <ArchiveFlag />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/project-plan`:
        return <ProjectPlan />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/forcast`:
        return <Forecast />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/departments`:
        // return <DepartmentComponent />;
        return <Departments />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/appDetails`:
        return <AppDetails />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/appCosts`:
        return <AppCosts />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/security`:
        return <Security />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/projects`:
        return <Projects />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/financials`:
        return <Financials />;
      case `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/appDiscovery`:
        return <AppDiscovery />;
      default:
        return (
          <ModuleSearchPage module={params.module_name} menuItem={menuItem} />
        );
    }
  };

  // if (isMini) {
  //   return (
  //     <>
  //       <Header onOpenNav={nav.onTrue} />

  //       <Box
  //         sx={{
  //           minHeight: 1,
  //           display: 'flex',
  //           flexDirection: {xs: 'column', lg: 'row'}
  //         }}>
  //         {lgUp ? renderNavMini : renderNavVertical}

  //         <Main>
  //           {menuItem === FormConstants.SCREENS.REPORTS ? (
  //             <GLReportsComponent
  //               module={params?.module_name}
  //               menu_item={menuItem}
  //             />
  //           ) : applicationName === 'App_Rationalization' ? (
  //             getModulePageItemAR()
  //           ) : (
  //             getModulePageItem()
  //           )}
  //         </Main>
  //       </Box>
  //     </>
  //   );
  // }

  const notFound = searchQuery.toString() && !searchResults?.length;

  const generateColumns = (data: any) => {
    if (!data || data.length === 0) return [];

    return Object.keys(data[0]).map(key => ({
      field: key,
      headerName: key.charAt(0).toUpperCase() + key.slice(1),
      flex: 1
    }));
  };

  const SearchResultsDataGrid = () => {
    const rows = Array.isArray(searchResults) ? searchResults : [];
    const [paginationModel, setPaginationModel] = React.useState({
      pageSize: 20,
      page: 0
    });

    const columns = generateColumns(rows);

    return (
      <Box sx={{height: '100%', width: '100%'}}>
        <DataGridComponent
          sectionUIData={[]}
          module={params.module_name}
          sub_module={params?.submodule_name}
          columns={columns}
          rows={rows}
          page={paginationModel?.page}
          pageSize={paginationModel?.pageSize}
          onPaginationModelChange={setPaginationModel}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          isFromModules={true}
          paginationMode="server"
          sortingMode="server"
          sortingOrder={['desc', 'asc']}
          getRowId={(row: any) => row.ID}
          sx={{
            pt: 4
          }}
        />
      </Box>
    );
  };

  return (
    <>
      {!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED && (
        <Header
          onOpenNav={nav.onTrue}
          globalSearch={false}
          search={search}
          onSearch={handleSearch}
          setSearchResults={setSearchResults}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          module={params.module_name}
          record_id={recordId}
          legacyApp={legacyApp}
          renderParentLegacyAppFilter={renderParentLegacyAppFilter}
          ParentLegacyValue={ParentLegacyValue}
          onHelpOptionClick={handleHelpOptionClick}
        />
      )}

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: {xs: 'column', lg: 'row'}
        }}>
        {isMini && lgUp ? renderNavMini : renderNavVertical}
        {loading || isSearching ? (
          <LoadingScreen search={isSearching} />
        ) : selectedHelpOption?.length ? (
          <Box
            sx={{
              width: '100%',
              height: '100vh',
              justifyContent: 'center',
              display: 'flex'
            }}>
            <iframe
              src={selectedHelpOption}
              title={'Help Option Content'}
              style={{
                width: '99%',
                height: '92vh',
                marginTop: '68px',
                borderRadius: '8px',
                borderColor: '#f4f6f8',
                border: '0px'
              }}
            />
          </Box>
        ) : (
          <Main>
            <Container maxWidth={settings.themeStretch ? false : 'lg'}>
              {searchResults ? (
                notFound ? (
                  <Stack
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="85vh">
                    <SearchNotFound query={searchQuery} sx={{py: 10}} />
                  </Stack>
                ) : (
                  <SearchResultsDataGrid />
                )
              ) : menuItem === FormConstants.SCREENS.REPORTS ? (
                <GLReportsComponent
                  module={params?.module_name}
                  menu_item={menuItem}
                />
              ) : applicationName === 'App_Rationalization' ? (
                getModulePageItemAR()
              ) : (
                getModulePageItem()
              )}
            </Container>
          </Main>
        )}
      </Box>
    </>
  );
};
export default ModulesMenuHomePage;

